import { Component, Input, OnInit } from '@angular/core';
import { RegistrationLocation, toLocation } from 'src/app/api/location/registrationLocation';
import { Location } from '../../../api/location/location';

@Component({
    selector: 'location-tree',
    templateUrl: './location-tree.component.html',
    styleUrls: ['./location-tree.component.css'],
    standalone: false
})
export class LocationTreeComponent implements OnInit {
  @Input() location: RegistrationLocation | null | undefined = null;  
  parents: string[] = [];
  functionalLocation: Location | null = null;
  
  ngOnInit(): void {
    if(this.location == null || this.location == undefined) {
     return;
    }
    
    this.setFunctionalLocation(this.location);
  }

  setFunctionalLocation(regLocation: RegistrationLocation) {
    if(regLocation.location == null || regLocation.location == undefined)
    {
      this.functionalLocation = toLocation(regLocation);
      return;
    }

    this.parents.push(regLocation.name!);
    this.setFunctionalLocation(regLocation.location);
  }
}
